import { TaskConstants } from '../../constants';
const tableHeadList = [{
  id: 'taskStatus',
  label: TaskConstants.HEADING_STATUS,
  showSortIcon: true,
  styles: {
    variant: 'regularBold',
    color: 'darkGray.900'
  }
}, {
  id: 'borrowerName',
  label: TaskConstants.HEADING_BORROWER_NAME,
  showSortIcon: false,
  styles: {
    variant: 'regularBold',
    color: 'darkGray.900'
  }
}, {
  id: 'name',
  label: TaskConstants.HEADING_TASK_NAME,
  showSortIcon: true,
  width: 788,
  styles: {
    variant: 'regularBold',
    color: 'darkGray.900'
  }
}, {
  id: 'uploadedFiles',
  label: TaskConstants.HEADING_UPLOADED_FILES,
  showSortIcon: false,
  width: 148,
  styles: {
    variant: 'regularBold',
    color: 'darkGray.900',
    display: 'flex',
    justifyContent: 'center'
  }
}, {
  id: 'upload',
  label: '',
  width: 206
}, {
  id: 'showMore',
  label: '',
  width: 56
}];
export const TableData = {
  tableHeadList
};
//# sourceMappingURL=TableData.js.map